export default "__VITE_ASSET__B1c8YWv7__"